import { render, staticRenderFns } from "./CompanyUnarchiveValues.vue?vue&type=template&id=3face67a&scoped=true&"
import script from "./CompanyUnarchiveValues.vue?vue&type=script&lang=js&"
export * from "./CompanyUnarchiveValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3face67a",
  null
  
)

export default component.exports